// @ts-nocheck

// @ts-nocheck
import axios, { type AxiosError, type AxiosRequestConfig } from "axios";
import { JWT_EXPIRED_ERROR_MESSAGE } from "@/constants/jwt.constants";
import { performRefreshToken } from "@/helpers/refreshTokenManager";
import { accessTokenAtom, store } from "@/store";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

const axiosConfig: AxiosRequestConfig = {
  baseURL: apiBaseUrl,
};

const axiosServerClient = axios.create(axiosConfig);

// Interceptor to add dynamic Authorization header with access token
axiosServerClient.interceptors.request.use(
  (config) => {
    const token = store.get(accessTokenAtom);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor to add Authorization header with access token
axiosServerClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError) => {
    const parsedErrorData = error.response?.data as
      | { message: string }
      | undefined;

    if (
      error.status === 400 &&
      parsedErrorData?.message === JWT_EXPIRED_ERROR_MESSAGE
    ) {
      try {
        // Use centralized refresh token manager
        await performRefreshToken();
        // Retry the original request with the new token
        return axiosServerClient(error.config);
      } catch (refreshError) {
        // If the refresh failed, reject the request
        return Promise.reject(refreshError);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export const createApiClient = <T>(
  ClientType: new (
    config: { basePath: string; isJsonMime: () => boolean },
    arg2: undefined,
    client: typeof axiosServerClient
  ) => T
) => {
  const apiClient = new ClientType(
    {
      basePath: apiBaseUrl,
      isJsonMime: () => false,
    },
    undefined,
    axiosServerClient
  );

  return apiClient;
};
